import { render } from "./Small.vue?vue&type=template&id=4d76ca59"
import script from "./Small.vue?vue&type=script&lang=js"
export * from "./Small.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../SINTEZ/store/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__